import {LoadableApp} from "ui-seeker/core"
import {REAL_TIME} from "app/config"

const Dashboard = LoadableApp(import("./"))

const PageRoutes = [
    {path: REAL_TIME.path, component: Dashboard, needLogin: false, header: false, onlyPage: true}
]

export default PageRoutes